import Skeleton from "../ui/Skeleton";

const searchbarSkeletonCSS = {
  position: "relative",
  mx: "auto",
  display: "flex",
  width: "100%",
  height: "50px",
  rounded: "full",
  md: {
    mr: "0",
    ml: "auto",
    mb: "0",
  },
};

function SearchbarSkeleton() {
  return (
    <>
      <Skeleton css={searchbarSkeletonCSS} />
    </>
  );
}

export default SearchbarSkeleton;
